import React, { useEffect, useState } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import {
    Collapse,
    Navbar,
    NavbarToggler,
    Nav,
    NavItem,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import { ReactComponent as Logo } from './../../assets/sureda_asociados--logo.svg';

import './navbar-rb.styles.scss';

const NavbarRB = () => {
    const [scrollTop, setScrollTop] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const toggle = () => setIsOpen(!isOpen);

    useEffect(() => {
        const onScroll = (e) => {
            setScrollTop(!Boolean(e.target.documentElement.scrollTop));
        };
        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, [scrollTop]);

    return (
        <div className={`navbar-container ${!scrollTop ? 'scroll' : ''}`}>
            <Navbar expand='md' light className=''>
                <Link smooth to='/#top' className='navbar-brand'>
                    <Logo />
                </Link>
                <NavbarToggler
                    onClick={toggle}
                    className={`${isOpen ? 'open' : ''}`}
                />
                <Collapse isOpen={isOpen} navbar>
                    <Nav className='' navbar>
                        <UncontrolledDropdown nav inNavbar>
                            <DropdownToggle nav caret>
                                PROYECTOS
                            </DropdownToggle>
                            <DropdownMenu left='true'>
                                <DropdownItem divider />
                                <DropdownItem>
                                    <Link
                                        smooth
                                        to='/residencial'
                                        onClick={toggle}
                                    >
                                        RESIDENCIAL
                                    </Link>
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem>
                                    <Link
                                        smooth
                                        to='/comercial'
                                        onClick={toggle}
                                    >
                                        COMERCIAL
                                    </Link>
                                </DropdownItem>
                                <DropdownItem divider />
                                <DropdownItem>
                                    <Link
                                        smooth
                                        to='/desarrollos'
                                        onClick={toggle}
                                    >
                                        DESARROLLOS
                                    </Link>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                        <NavItem>
                            <Link
                                smooth
                                to='/concursos'
                                className='nav-link'
                                onClick={toggle}
                            >
                                CONSURSOS
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link
                                smooth
                                to='/#nosotros'
                                className='nav-link'
                                onClick={toggle}
                            >
                                NOSOTROS
                            </Link>
                        </NavItem>
                        <NavItem>
                            <Link
                                smooth
                                to='/#contacto'
                                className='nav-link'
                                onClick={toggle}
                            >
                                CONTACTO
                            </Link>
                        </NavItem>
                    </Nav>
                </Collapse>
            </Navbar>
        </div>
    );
};

export default NavbarRB;
